<template>
  <div>
    <iframe
      width="100%"
      :style="{'height': iframeHeight}"
      :src="vimeoUrl()"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>
<script>
import { getVimeoEmbedUrl } from "@/helpers";
import i18n from "@/i18n";
export default {
  name: "VimeoLive",
  props: {
    meta: {
      type: Object,
      default: null,
    },
  },
  mounted() {
      this.showNotification()
  },
  computed: {
      iframeHeight() {
        // const isFullScreenWithEmbed = this.meta.isEmbedMode && this.meta.isFullScreenMode
        return this.meta.isFullScreenMode ? '98vh' :'600px'
      }
  },
  methods: {
    vimeoUrl(autoplay = true) {
      return getVimeoEmbedUrl(this.meta.vimeo_live_id, autoplay);
    },

    /** Show notification: Event is about to start */
    showNotification() {
      this.$store.dispatch("app/showSupportNotification", {
        screener_id: this.meta.screener_id,
        message: this.meta.title + i18n.t("screener.meeting.is_about_to_stream")
      });
    }
  },
};
</script>
